import React from 'react';
import { Row, Col, Form } from 'react-bootstrap';

/**
 * @component QuestionOptions
 * @description
 * Componente que muestra una lista de opciones tipo radio (opción múltiple) para una pregunta.
 * Cada opción se muestra como un botón seleccionable. Permite seleccionar solo una respuesta a la vez.
 *
 * Utiliza los componentes de `react-bootstrap` para el diseño.
 *
 * @param {Object} props
 * @param {Array} props.answers - Lista de respuestas posibles, cada una con una propiedad `option`
 * @param {Object} props.selected - Respuesta seleccionada actualmente
 * @param {Function} props.onChange - Función que se ejecuta al seleccionar una opción
 * @param {number|string} props.questionId - ID de la pregunta (usado para agrupar el input radio)
 *
 * @returns {JSX.Element}
 *
 * @example
 * <QuestionOptions
 *   answers={[{ option: 'A' }, { option: 'B' }]}
 *   selected={{ option: 'A' }}
 *   onChange={(answer) => console.log(answer)}
 *   questionId={5}
 * />
 */
const QuestionOptions = ({ answers, selected, onChange, questionId }) => (
	<Row className="mt-3">
		{answers.map((answer, i) => (
			<Col key={i} md={3}>
				<Form.Check type="radio" id={`answer-${i}`}>
					<Form.Check.Input
						type="radio"
						name={`answer-${questionId}`}
						value={answer.option}
						checked={selected?.option === answer.option}
						onChange={() => onChange(answer)}
					/>
					<Form.Check.Label className="ms-2">{answer.option}</Form.Check.Label>
				</Form.Check>
			</Col>
		))}
	</Row>
);

export default QuestionOptions;